import '../scss/cookie-notice.scss';

(function () {
  const COOKIE_NAME = 'cookie_notice_accepted';
  const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;
  const POLICY_URL = '/policy';
  const ROOT_CLASS = 'has-cookie-notice';
  // Фиксированные панели внизу экрана, над которыми встаёт полоса
  const BOTTOM_PANELS_SELECTOR = '.dke_help-block__container';
  const CLOSE_ICON =
    '<svg viewBox="0 0 14 14" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.8428 0.916277C14.0524 0.706666 14.0524 0.366819 13.8428 0.157208C13.6332 -0.0524029 13.2933 -0.0524027 13.0837 0.157208L6.99974 6.24119L0.916277 0.157733C0.706666 -0.0518785 0.366819 -0.0518787 0.157208 0.157732C-0.0524029 0.367344 -0.0524027 0.70719 0.157208 0.916801L6.24067 7.00026L0.179554 13.0614C-0.0300571 13.271 -0.0300572 13.6108 0.179554 13.8204C0.389165 14.0301 0.729012 14.0301 0.938623 13.8204L6.99974 7.75933L13.0614 13.821C13.271 14.0306 13.6108 14.0306 13.8204 13.821C14.0301 13.6114 14.0301 13.2715 13.8204 13.0619L7.75881 7.00026L13.8428 0.916277Z"/></svg>';

  const TEXTS = {
    ru: {
      label: 'Уведомление о cookies',
      title: 'Мы используем cookies.',
      text: 'Не те, что берут с собой на прогулку, но тоже полезные. Используя сайт, вы соглашаетесь на',
      policyLink: 'обработку персональных данных',
      accept: 'Принимаю, но от настоящих не откажусь',
      close: 'Закрыть',
    },
    en: {
      label: 'Cookie notice',
      title: 'We use cookies.',
      text: 'Not the kind you pack for a trip, but useful ones too. By using this website, you agree to the',
      policyLink: 'processing of your personal data',
      accept: 'Sure, but real ones too',
      close: 'Close',
    },
  };
  const texts = TEXTS[document.currentScript?.dataset.lang] || TEXTS.ru;

  function isAccepted() {
    return document.cookie
      .split('; ')
      .some(cookie => cookie === `${COOKIE_NAME}=1`);
  }

  function saveAccepted() {
    document.cookie = `${COOKIE_NAME}=1; max-age=${COOKIE_MAX_AGE}; path=/; SameSite=Lax`;
  }

  function getBottomPanelsOffset() {
    const viewportHeight = window.innerHeight;
    let offset = 0;

    document.querySelectorAll(BOTTOM_PANELS_SELECTOR).forEach(panel => {
      if (getComputedStyle(panel).position !== 'fixed') return;

      const { top, height } = panel.getBoundingClientRect();
      if (!height || top >= viewportHeight) return;

      offset = Math.max(offset, viewportHeight - top);
    });

    return Math.ceil(offset);
  }

  function createNotice() {
    const notice = document.createElement('aside');

    notice.className = 'dke_cookie-notice';
    notice.setAttribute('aria-label', texts.label);
    notice.innerHTML = `
      <div class="dke_cookie-notice__container">
        <p class="dke_cookie-notice__text">
          <span class="dke_cookie-notice__title">${texts.title}</span> ${texts.text} <a class="dke_cookie-notice__link" href="${POLICY_URL}">${texts.policyLink}</a>.
        </p>
        <button type="button" class="dke_cookie-notice__accept js_dke_cookie-notice__accept">${texts.accept}</button>
        <button type="button" class="dke_cookie-notice__close js_dke_cookie-notice__accept" aria-label="${texts.close}" title="${texts.close}">${CLOSE_ICON}</button>
      </div>
    `;
    return notice;
  }

  function init() {
    if (isAccepted() || document.querySelector('.dke_cookie-notice')) return;

    const root = document.documentElement;
    const notice = createNotice();
    let frameId = 0;

    const update = () => {
      cancelAnimationFrame(frameId);
      frameId = requestAnimationFrame(() => {
        const height = Math.ceil(notice.getBoundingClientRect().height);
        const panelsOffset = getBottomPanelsOffset();
        const vpnOffset =
          parseFloat(
            getComputedStyle(root).getPropertyValue('--vpn-banner-fixed-offset')
          ) || 0;

        notice.style.setProperty(
          '--cookie-notice-panels-offset',
          `${panelsOffset}px`
        );
        root.style.setProperty('--cookie-notice-height', `${height}px`);
        root.style.setProperty(
          '--cookie-notice-offset',
          `${Math.max(panelsOffset, vpnOffset) + height}px`
        );
      });
    };

    const resizeObserver = window.ResizeObserver
      ? new ResizeObserver(update)
      : null;

    const hide = () => {
      saveAccepted();
      cancelAnimationFrame(frameId);
      resizeObserver?.disconnect();
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
      window.removeEventListener('vpn-banner:offset-change', update);
      document.removeEventListener('transitionend', update);
      root.classList.remove(ROOT_CLASS);
      root.style.removeProperty('--cookie-notice-height');
      root.style.removeProperty('--cookie-notice-offset');
      notice.remove();
    };

    notice
      .querySelectorAll('.js_dke_cookie-notice__accept')
      .forEach(button => button.addEventListener('click', hide));

    document.body.appendChild(notice);
    root.classList.add(ROOT_CLASS);
    resizeObserver?.observe(notice);
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('vpn-banner:offset-change', update);
    document.addEventListener('transitionend', update);
    update();
  }

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  }
})();
